<script lang="ts" setup>
defineProps<{ stars: Rating, size?: 'xl' | '2xl' }>()
</script>

<template>
  <div
    v-if="stars"
    class="flex"
  >
    <Icon
      v-for="(i, index) in 5"
      :key="index"
      v-motion-pop-visible
      :name="stars <= index ? 'ri:star-line' : 'ri:star-fill'"
      class=" duration-150"
      :class="[size === 'xl' ? 'w-10 h-10 lg:w-12 lg:h-12' : size === '2xl' ? 'w-10 h-10 md:h-12 md:w-12 lg:h-16  lg:w-16 ' : 'w-8 h-8 md:h-6 md:w-6 lg:h-8  lg:w-8 ']"
      :delay="(index + 1) * 50"
    />
  </div>
</template>
